<template>
    <div class="lms__superadmin_users_profile_add">
        <div class="lms__superadmin_users_profile_add_header">
            <view-actions
                :title="'Invite user'"
                :cancel-button-text="'Cancel'"
                :cancel-notify-active="false"
                :submit-button-active="true"
                :submit-button-disabled="!profileEmail || !profileFirstName || !profileLastName || !profileRoles.length || !profileWorkspaceId || !profileCustomerId || userProfileAlreadyExists"
                :submit-button-text="'Send invitation'"
                :submit-button-animate-loading="true"
                :submit-button-animate-loading-event-name="'invite-user'"
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: 'Users',
                        to: backToUsers
                    }
                ]"
                @emit-cancel="stopAddUser"
                @emit-submit="performSubmitValidate"
            />
        </div>
        <div class="lms__superadmin_users_profile_add_main">
            <div class="container">
                <div class="columns custom--centered">
                    <div class="column is-5-desktop is-7-tablet is-12-mobile">
                        <lms-superadmin-users-profile-edit-details/>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import LmsSuperadminUsersProfileEditDetails from '@/components/lms/superadmin/users/profile/edit/LmsSuperadminUsersProfileEditDetails'
import { validateBeforeRouteLeave, performSubmitValidate } from '@/helpers/mixins'
import PopNotify from '@/components/default/shared/PopNotify'

export default {
  name: 'lms-superadmin-users-profile-add',
  components: { PopNotify, LmsSuperadminUsersProfileEditDetails, ViewActions },
  mixins: [validateBeforeRouteLeave, performSubmitValidate],
  computed: {
    backToUsers () {
      return { name: 'lms-superadmin-user-list' }
    },
    //
    rootItemName () {
      return 'user-profile'
    },
    nameActionCreate () {
      return 'lmsSuperadminWorkspaceUserProfileCreate'
    },
    paramsActionCreate () {
      return { redirect: false }
    },
    userAlreadyInvited () {
      return Boolean(this.$store.getters.getLmsSuperadminWorkspaceUserProfileIsAlreadyInvited)
    },
    userProfileAlreadyExists () {
      return Boolean(this.$store.getters.getLmsSuperadminWorkspaceUserProfileAlreadyExists)
    },
    profileEmail () {
      return this.$store.getters.getLmsSuperadminWorkspaceUserProfileEmail
    },
    profileFirstName () {
      return this.$store.getters.getLmsSuperadminWorkspaceUserProfileFirstName
    },
    profileLastName () {
      return this.$store.getters.getLmsSuperadminWorkspaceUserProfileLastName
    },
    profileRoles () {
      return this.$store.getters.getLmsSuperadminWorkspaceUserProfileRoles
    },
    profileWorkspaceId () {
      return this.$store.getters.getLmsSuperadminWorkspaceUserProfileToWorkspace
    },
    profileCustomerId () {
      return this.$store.getters.getLmsSuperadminWorkspaceUserProfileCustomerId
    }
  },
  methods: {
    stopAddUser () {
      this.$router.push({ name: 'lms-superadmin-user-list' })
    },
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('user-submit')
    },
    performSubmitValidateThenCallback () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'lms-superadmin-user-list' })
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-invite-user')
    },
    performSubmitValidateValidationCallback () {
      this.$eventBus.$emit('stop-invite-user')
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminusersprofileeditshow.scss";
</style>
